import { all, call, put, select, takeEvery } from "redux-saga/effects";
import { getDataFromSxi, getJwtToken } from "api";
import { ENDPOINT, PICTREE } from "../../constants";
import { setSaitamaReportOverview } from "actions";
import { SAITAMA_SEASON } from "reducers/pictree/pictreeSaitamaReducer";
import { toSaitamaUtcBounds, normalizeRows } from "helper/pictreeSaitamaPhotoShoot";
import { buildSaitamaReportOverview, buildSaitamaReportQueries } from "helper/pictreeSaitamaReport";

const selectedSeason = (state) => state.pictreeSaitama.selectedSeason;
const dateRange = (state) => state.pictreeSaitama.dateRange;

export const SAITAMA_REPORT_QUERY_ENDPOINT = ENDPOINT.GET_DATA_SXI_DENCHU;

export function* getSaitamaReportOverviewData() {
  try {
    const token = yield call(getJwtToken);
    const season = (yield select(selectedSeason))[0] || SAITAMA_SEASON;
    const range = yield select(dateRange);
    const bounds = toSaitamaUtcBounds(range, season);
    const queries = buildSaitamaReportQueries({ seasonId: season.seasonId, ...bounds });
    const keys = ["reportCount", "reporterCount", "tags", "trend"];
    const results = yield all(keys.map((key) => call(
      getDataFromSxi,
      queries[key],
      SAITAMA_REPORT_QUERY_ENDPOINT,
      token
    )));
    const responses = keys.reduce((acc, key, index) => {
      acc[key] = normalizeRows(results[index]);
      return acc;
    }, {});
    yield put(setSaitamaReportOverview(buildSaitamaReportOverview({ responses, dateRange: range })));
  } catch (error) {
    yield put(setSaitamaReportOverview({ status: "error", error: error.message || "Saitama report data request failed" }));
  }
}

export default function* watchSaitamaReport() {
  yield takeEvery(PICTREE.GET_SAITAMA_REPORT_OVERVIEW, getSaitamaReportOverviewData);
}

